"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A411))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:25.414Z
 */
export const UnitedKingdom = createSVGIcon(
  <>
    <rect x="1" y="1.17578" width="16" height="12" fill="#354992" />
    <rect x="7" y="1.17578" width="4" height="12" fill="white" />
    <rect x="1" y="5.17578" width="16" height="4" fill="white" />
    <rect
      x="16.8418"
      y="1"
      width="1"
      height="19.5609"
      transform="rotate(53.98 16.8418 1)"
      fill="white"
    />
    <rect
      width="1"
      height="19.5609"
      transform="matrix(0.588067 -0.808812 -0.808812 -0.588067 16.8418 13.3125)"
      fill="white"
    />
    <rect x="8" y="1.17578" width="2" height="12" fill="#B64343" />
    <rect
      x="17"
      y="6.17578"
      width="2"
      height="16"
      transform="rotate(90 17 6.17578)"
      fill="#B64343"
    />
    <rect x="1" y="1.17578" width="16" height="12" stroke="#757575" />
  </>,
  "UnitedKingdom",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "United Kingdom flag",
      description: { text: "The label for the United Kingdom flag icon" },
    }),
  })
);
